import wretchAdapter from '@/shared/api/adapters/wretch';
import defaultRequestConfig from '@/shared/api/adapters/wretch/defaultRequestConfig';

const getWorkchatRequestConfig = (requestDecorator?: (requestConfig: any) => any) => {
  // For whatever odd reason, WC API doesn't like it when we send these headers
  const requestConfig = defaultRequestConfig();
  delete requestConfig.headers['W-Date-Format'];

  if (requestConfig.headers.Authorization) {
    delete requestConfig.headers.Authorization;
  }

  if (requestDecorator) {
    return requestDecorator(requestConfig);
  }

  return requestConfig;
};

export const workchatGo = wretchAdapter(CONFIG.WORKCHAT_GO_ROOT, getWorkchatRequestConfig());

export const workchatGoImage = wretchAdapter(
  CONFIG.WORKCHAT_GO_ROOT,
  getWorkchatRequestConfig(requestConfig => {
    // Remove Content-Type header so that the browser can send multipart data with the proper type
    // i.e. multipart/form-data; boundary=----WebKitFormBoundaryBBlOaBpRGeTCMBus
    delete requestConfig.headers['Content-Type'];
    return requestConfig;
  }),
);

export default wretchAdapter(CONFIG.WORKCHAT_ROOT, getWorkchatRequestConfig());
